import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import Section from '../components/Section';

export default () => (
  <Section id="news">
    <h1><FormattedHTMLMessage id="pages:news:title" /></h1>
    <FormattedHTMLMessage id="pages:news:description" />
  </Section>
);



// WEBPACK FOOTER //
// ./src/sections/News.js